import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65d68464"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
  /*#__PURE__*/_createElementVNode("h1", null, " Roles Template "),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("Roles can be used in process templates instead of dedicated users to assign task to users. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" These roles can then be resolved with real email addresses when creating a new process.")
  ])
], -1))
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "mt-4" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "mb-5" }, "Roles", -1))
const _hoisted_9 = {
  for: "inputEmail4",
  class: "form-label"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "string",
  class: "form-control",
  id: "inputEmail4",
  disabled: "true",
  placeholder: "E-Mail Address is set while process creation"
}, null, -1))
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "card" }
const _hoisted_13 = { class: "card-body" }
const _hoisted_14 = { class: "mt-4" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "mb-5" }, "Roles", -1))
const _hoisted_16 = {
  for: "inputEmail4",
  class: "form-label"
}
const _hoisted_17 = ["onUpdate:modelValue", "onChange"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_help_tooltip = _resolveComponent("help-tooltip")!
  const _component_context_menu = _resolveComponent("context-menu")!
  const _component_AddRoleModal = _resolveComponent("AddRoleModal")!
  const _component_RenameRoleModal = _resolveComponent("RenameRoleModal")!
  const _component_DeleteRoleModal = _resolveComponent("DeleteRoleModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h2", null, [
                _createTextVNode("Extern "),
                _createVNode(_component_help_tooltip, { text: "The external party indicates your customers, i.e. the buyer." })
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: "btn btn-primary float-end",
                  "data-bs-toggle": "modal",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.type = 'EXTERN')),
                  "data-bs-target": "#addRoleModal"
                }, " Add "),
                _hoisted_8,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.externRoles, (role) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "mt-4 mb-4",
                    key: role.roleId
                  }, [
                    _createVNode(_component_context_menu, {
                      class: "pull-end",
                      onClick: _withModifiers(($event: any) => (_ctx.selectedItemId = role.roleId), ["stop"]),
                      id: role.roleId,
                      links: [
                                            {
                                                text: 'Rename',
                                                icon: 'edit-3',
                                                bsTarget: '#renameRoleModal',
                                            }, {
                                                text: 'Delete',
                                                icon: 'trash-2',
                                                bsTarget: '#deleteRoleModal',
                                            },
                                        ]
                    }, null, 8, ["onClick", "id"]),
                    _createElementVNode("label", _hoisted_9, _toDisplayString(role.name), 1),
                    _hoisted_10
                  ]))
                }), 128))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("h2", null, [
                _createTextVNode("Intern "),
                _createVNode(_component_help_tooltip, { text: "The internal party indicates your company, i.e. the seller." })
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", {
                  class: "btn btn-primary float-end",
                  "data-bs-toggle": "modal",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.type = 'INTERN')),
                  "data-bs-target": "#addRoleModal"
                }, " Add "),
                _hoisted_15,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.internRoles, (role) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "mt-4 mb-4",
                    key: role.roleId
                  }, [
                    _createVNode(_component_context_menu, {
                      class: "pull-end",
                      onClick: _withModifiers(($event: any) => (_ctx.selectedItemId = role.roleId), ["stop"]),
                      id: role.roleId,
                      links: [
                                            {
                                                text: 'Rename',
                                                icon: 'edit-3',
                                                bsTarget: '#renameRoleModal',
                                            }, {
                                                text: 'Delete',
                                                icon: 'trash-2',
                                                bsTarget: '#deleteRoleModal',
                                            },
                                        ]
                    }, null, 8, ["onClick", "id"]),
                    _createElementVNode("label", _hoisted_16, _toDisplayString(role.name), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "string",
                      "onUpdate:modelValue": ($event: any) => ((role.defaultEmailAddress) = $event),
                      class: "form-control",
                      id: "inputEmail4",
                      placeholder: "Default E-Mail Address",
                      onChange: ($event: any) => (_ctx.updateDefaultEmail(role, $event))
                    }, null, 40, _hoisted_17), [
                      [_vModelText, role.defaultEmailAddress]
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_AddRoleModal, {
        onAdded: _cache[2] || (_cache[2] = ($event: any) => (_ctx.go($event))),
        type: _ctx.type,
        "onUpdate:type": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.type) = $event))
      }, null, 8, ["type"]),
      _createVNode(_component_RenameRoleModal, { roleId: _ctx.selectedItemId }, null, 8, ["roleId"]),
      _createVNode(_component_DeleteRoleModal, { roleId: _ctx.selectedItemId }, null, 8, ["roleId"])
    ])
  ]))
}